import axios from "axios";
import { CURR_API } from "@/constants/apis";
import { sessionActorFrom } from "@/utils/sessionIdentity";
import { peekSessionSelfProfile } from "@/stores/sessionSelf";

/**
 * Match keyon/tswebhook.php response shapes (sometimes nested under a single top-level key).
 */
export function normalizePrivilegesPayload(data) {
  if (!data || typeof data !== "object") return {};
  if (
    Object.prototype.hasOwnProperty.call(data, "status") ||
    Object.prototype.hasOwnProperty.call(data, "data")
  ) {
    return data;
  }
  const keys = Object.keys(data);
  if (keys.length === 1 && data[keys[0]] && typeof data[keys[0]] === "object") {
    return data[keys[0]];
  }
  return data;
}

/**
 * Resolve keyon accountnumber + unique_ID for the session actor.
 * Prefers MySQL sessionSelf (GetSelfProfile); falls back to PHR allData.
 *
 * @param {object} phrData Vuex login/getAllData
 * @param {object|null|undefined} sessionSelf optional explicit profile; when
 *   undefined, reads useSessionSelfStore().profile if Pinia is active
 */
export function resolveKeyonPrivilegeIdentity(phrData, sessionSelf) {
  const actor = sessionActorFrom(phrData, peekSessionSelfProfile(sessionSelf));
  return {
    accountnumber: actor.accountnumber,
    unique_ID: actor.unique_ID,
  };
}

/**
 * Loads effective privilege rows for the logged-in user (groups + overrides) from MySQL via keyon.
 */
export async function fetchUserPrivilegeAssignments(phrData) {
  const { accountnumber, unique_ID } = resolveKeyonPrivilegeIdentity(phrData);
  if (!accountnumber || !unique_ID) {
    return {
      ok: false,
      data: [],
      error: "missing_identity",
      accountnumber,
      unique_ID,
    };
  }
  const content = {
    Privileges: {
      API_Meth: "GetPrivilegeAssignmentsForSubject",
      accountnumber,
      subject_type: "user",
      unique_ID,
    },
  };
  const res = await axios.post(`${CURR_API}/tswebhook.php`, content, {
    headers: { "Content-Type": "application/json;" },
  });
  const payload = normalizePrivilegesPayload(res.data);
  const ok = payload && String(payload.status || "").toLowerCase().includes("success");
  const list = ok && Array.isArray(payload.data) ? payload.data : [];
  return {
    ok,
    data: list,
    accountnumber,
    unique_ID,
  };
}
